module.exports = __webpack_public_path__ + "static/media/perfect-circle-annoyed.9e099593.ogg";